import { jsx } from "react/jsx-runtime";
import { Link } from "@nxt-costco-com/forge-components";
import { Analytics } from "../../../Analytics/index.js";
function WishlistLink({ entry }) {
  if (!entry) return null;
  const { title, href } = entry.active_state.active_state_link;
  return /* @__PURE__ */ jsx(
    Analytics,
    {
      analyticData: {
        component: {
          trackedData: [title]
        }
      },
      children: /* @__PURE__ */ jsx(Link, { href, uniqueId: "wishlist", variant: "t6", children: title })
    }
  );
}
export {
  WishlistLink
};
